<script setup lang="ts">
  import type { JourneyData } from '@/models/journey';
  import JourneyCard from '@/components/journey/JourneyCard.vue';
  import { useJourney } from '@/composables/useJourney';
  import type { PropType } from 'vue';

  defineProps({
    journeySectionData: {
      type: Object as PropType<JourneyData>,
      required: true
    }
  });

  const { swiperRef, currentIndex, paused, backDirection, isInitialized, slideChange, click } = useJourney();
</script>

<template>
  <section class="journey-section">
    <div class="container">
      <div class="journey-section__wrapper">
        <div class="journey-section__heading">
          <h1 class="journey-section__title">{{ journeySectionData.heading }}</h1>
          <div class="journey-section__tag">
            <div class="journey-section__tag-wrapper">
              <div class="journey-section__tag-left">
                <img
                  src="@/assets/images/computer.svg"
                  alt="computer" />
              </div>
              <div class="journey-section__tag-right">
                <p class="journey-tag-line-1">{{ journeySectionData.tagFirstLine }}</p>
                <p class="journey-tag-line-2">{{ journeySectionData.tagSecondLine }}</p>
                <p class="journey-tag-line-3">{{ journeySectionData.tagThirdLine }}</p>
              </div>
            </div>
          </div>
          <p class="journey-section__info">
            {{ journeySectionData.description }}
          </p>
        </div>
        <div class="journey-section__body">
          <swiper-container
            ref="swiperRef"
            :class="[{ paused: paused, 'back-direction': backDirection, 'swiper-initialized': isInitialized }]"
            slides-per-view="auto"
            :space-between="0"
            :centered-slides="true"
            :rewind="false"
            :loop="false"
            :speed="800"
            :autoplay="{ delay: 5000, pauseOnMouseEnter: true, stopOnLastSlide: true }"
            :init="false"
            @swiperslidechange="slideChange">
            <swiper-slide
              v-for="(journey, index) in journeySectionData.items"
              :key="index"
              @click="click(index)">
              <JourneyCard
                :journey="journey"
                :index="index"
                :num-items="journeySectionData.items.length"
                :active="index === currentIndex"
                :step-text="journeySectionData.stepText" />
            </swiper-slide>
          </swiper-container>
        </div>
      </div>
    </div>
  </section>
</template>
